module.exports = __webpack_public_path__ + "img/002-dashboard.4cb1e267.png";